<span class="status__summary-text actual-row picker">
  <input
    ngDefaultControl
    type="time"
    [formControl]="timeControl"
    (change)="onChange()"
    />
  <mat-form-field class="status-tz" ngDefaultControl>
    <mat-select (valueChange)="onChange($event)" [value]="selectedTimezone.tz">
      @for (tz of timezones; track tz) {
        <mat-option [value]="tz.tz" >{{tz.abbr}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (substatusDate?.id || substatusDate?.date) {
    <mat-icon
      color="warn"
      style="cursor: pointer"
      matTooltip="Delete Date"
      (click)="deleteDateConfirmation()"
      >
      clear
    </mat-icon>
  }
</span>
